import { Bell, LayoutDashboard, LogOut, Menu, Settings, UserRoundPlus, UsersRound, X } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth";

const nav = [
  { to: "/", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/groups", label: "Groups & trips", icon: UsersRound },
  { to: "/friends", label: "Friends", icon: UserRoundPlus },
  { to: "/notifications", label: "Notifications", icon: Bell },
  { to: "/settings", label: "Settings", icon: Settings },
];

export function AppLayout() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  return <div className="app-shell">
    <a className="skip-link" href="#main">Skip to content</a>
    <header className="mobile-header">
      <Brand />
      <button className="icon-button" onClick={() => setOpen(!open)} aria-label="Toggle navigation">{open ? <X /> : <Menu />}</button>
    </header>
    <aside className={`sidebar ${open ? "sidebar-open" : ""}`}>
      <Brand />
      <nav aria-label="Primary navigation">
        {nav.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)}><Icon size={19} /><span>{label}</span></NavLink>)}
      </nav>
      <div className="sidebar-account">
        <div className="avatar" aria-hidden>{(user?.displayName || user?.email || "S")[0]?.toUpperCase()}</div>
        <div><strong>{user?.displayName || "Ghenti member"}</strong><small>{user?.email}</small></div>
        <button className="icon-button" onClick={() => void logout()} aria-label="Sign out"><LogOut size={18} /></button>
      </div>
    </aside>
    {open && <button className="scrim" onClick={() => setOpen(false)} aria-label="Close navigation" />}
    <main id="main" className="page"><Outlet /></main>
  </div>;
}

function Brand() {
  return <NavLink className="brand" to="/" aria-label="Split Sh*t home"><span className="brand-mark">S</span><span>Split Sh*t<small>by GhentiLabs</small></span></NavLink>;
}
